import { z } from 'zod';

// toolkitInfo 스키마 정의
const toolkitInfoSchema = z.object({
    toolkits: z.array(z.unknown()),
    toolbarAutoHide: z.boolean(),
    toolLayerAutoHide: z.boolean(),
    toolbarPosition: z.string(),
    toolbarStyle: z.string(),
    usernameHide: z.boolean(),
    tonlyAll: z.boolean(),
    randomPresetOrder: z.boolean(),
    seatswapperPresetOrder: z.boolean(),
    originImage: z.array(z.unknown()).nullable(),
    originImageSeq: z.array(z.unknown()).nullable(),
    thumbImage: z.array(z.unknown()).nullable(),
    thumbImageSeq: z.array(z.unknown()).nullable(),
    selectBg: z.string(),
    staticBgInit: z.boolean().nullable(),
    staticBg: z.boolean(),
    stopwatch: z.record(z.unknown()).nullable(),
    timer: z.record(z.unknown()).nullable(),
    dice: z.record(z.unknown()).nullable(),
    coin: z.record(z.unknown()).nullable(),
    random: z.record(z.unknown()).nullable(),
    wheel: z.record(z.unknown()).nullable(),
    memo: z.union([z.array(z.unknown()), z.record(z.unknown()).nullable()]),
    whistler: z.record(z.unknown()).nullable(),
    noisemonitor: z.record(z.unknown()).nullable(),
    qrcode: z.union([z.array(z.unknown()), z.record(z.unknown()).nullable()]),
    clock: z.record(z.unknown()).nullable(),
    crayon: z.record(z.unknown()).nullable(),
    board: z.record(z.unknown()).nullable(),
    classthermo: z.record(z.unknown()).nullable(),
    suggestionList: z.array(z.unknown()).nullable(),
    scoreboard: z.record(z.unknown()).nullable(),
    video: z.union([z.array(z.unknown()), z.record(z.unknown()).nullable()]),
    toolOrder: z.array(z.string()).nullable(),
    movedTools: z.array(z.string()).nullable(), //위치이동한 툴 저장체크로 추가
    nationalrite: z.record(z.unknown()).nullable(),
    seatswapper: z.record(z.unknown()).nullable(),
    air: z.record(z.unknown()).nullable(),
    digitaledutool: z.record(z.unknown()).nullable(),
    checklist: z.record(z.unknown()).nullable(),
    marble: z.record(z.unknown()).nullable(),
    tournament: z.record(z.unknown()).nullable(), //대진표 추가로 추가
    dday: z.record(z.unknown()).nullable(),
    note: z.record(z.unknown()).nullable(),
    classduty: z.record(z.unknown()).nullable(),
    dataMigrated: z.boolean(),
});

// toolkitInfo 검증 함수
export const validateToolkitInfo = (data) => {
    return toolkitInfoSchema.safeParse(data); // safeParse로 검증을 수행
};
